import axios from 'axios';
import { API_CONFIG } from '../contexts/constants';

class CKEditorUploadAdapter {
    constructor(loader) {
        this.loader = loader;
    }

    upload() {
        return this.loader.file.then(file => new Promise((resolve, reject) => {
            const formData = new FormData();
            formData.append('upload', file);

            axios.post(`${API_CONFIG.BASE_URL}/upload-image`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                },
                onUploadProgress: (progressEvent) => {
                    // Optional: Handle upload progress
                    if (progressEvent.lengthComputable) {
                        const percentComplete = (progressEvent.loaded / progressEvent.total) * 100;
                        console.log(`Upload Progress: ${percentComplete.toFixed(2)}%`);
                    }
                }
            })
            .then(response => {
                if (response.data && response.data.url) {
                    resolve({
                        default: response.data.url
                    });
                } else {
                    reject('อัปโหลดล้มเหลว: ไม่พบ URL ของรูปภาพ');
                }
            })
            .catch(error => {
                console.error('Upload error:', error);
                let errorMessage = 'ไม่สามารถอัปโหลดรูปภาพได้';

                if (error.response) {
                    errorMessage = error.response.data?.message || errorMessage;

                    if (error.response.status === 401 || error.response.status === 403) {
                        errorMessage = 'กรุณาเข้าสู่ระบบใหม่';
                    }
                } else if (error.request) {
                    errorMessage = 'ไม่สามารถเชื่อมต่อกับเซิร์ฟเวอร์ได้';
                }

                reject(errorMessage);
            });
        }));
    }

    abort() {
        // Optional: Implement abort functionality if needed
        console.log('Upload aborted');
    }
}

// Plugin function to integrate the adapter with CKEditor
export function CustomUploadAdapterPlugin(editor) {
    editor.plugins.get('FileRepository').createUploadAdapter = (loader) => {
        return new CKEditorUploadAdapter(loader);
    };
}

export default CKEditorUploadAdapter;
